import { createFileRoute, Outlet } from "@tanstack/react-router";

export type PalsSearch = { q?: string; element?: string; rarity?: string };

// Hand-rolled validator instead of zod: this layout route sits in the critical
// path of /pals and every /pals/<slug> page, and pulling zod in cost ~57 KB of
// JavaScript for three optional strings.
//
// Params must stay OPTIONAL with no defaults — a default value makes the router
// rewrite every /pals/* URL to `?q=&element=&rarity=`, which Google reports as
// "Alternate page with proper canonical tag" and which wastes crawl budget.
function str(v: unknown) {
  return typeof v === "string" && v ? v : undefined;
}

export const Route = createFileRoute("/pals")({
  validateSearch: (search: Record<string, unknown>): PalsSearch => {
    const out: PalsSearch = {};
    const q = str(search.q);
    const element = str(search.element);
    const rarity = str(search.rarity);
    if (q) out.q = q;
    if (element) out.element = element;
    if (rarity) out.rarity = rarity;
    return out;
  },
  component: Outlet,
});
